import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scroll to top on route change EXCEPT when only the language segment changed.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const stripLang = (p) => p.replace(/^\/(it|en)(?=\/|$)/, '');
    const prev = window.__prev_path__ || '';
    if (stripLang(prev) === stripLang(pathname)) {
      // Language switch only — keep scroll position.
      window.__prev_path__ = pathname;
      return;
    }
    window.__prev_path__ = pathname;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);

  return null;
}
